import { render, staticRenderFns } from "./VacationerItem.vue?vue&type=template&id=927d7f30"
import script from "./VacationerItem.ts?vue&type=script&lang=ts&external"
export * from "./VacationerItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports